import clsxm from '@/lib/clsxm';

import { Spacing } from '@/enums/spacing';

export enum SeparatorType {
  HorizontalLine = 'HORIZONTAL_LINE',
  VerticalLine = 'VERTICAL_LINE',
}

export type SeparatorProps = {
  separatorType?: SeparatorType;
  spacing?: Spacing;
};

const Separator = (props: SeparatorProps) => {
  let margin: string;

  switch (props.spacing) {
    case Spacing.SMALL:
      margin = 'my-2';
      break;
    case Spacing.MEDIUM:
      margin = 'my-6';
      break;
    case Spacing.LARGE:
      margin = 'my-12';
      break;
    case Spacing.NONE:
    default:
      margin = 'my-0';
      break;
  }

  return (
    <div className={clsxm(margin, 'min-h-[1px]')}>
      {props.separatorType === SeparatorType.HorizontalLine && (
        <HorizontalLine />
      )}
      {props.separatorType === SeparatorType.VerticalLine && <VerticalLine />}
    </div>
  );
};
export default Separator;

const HorizontalLine = () => <hr className='h-px border-0 bg-gray-200' />;

const VerticalLine = () => (
  <div className='mx-auto h-[68px] w-[3px] bg-primary' />
);
